import "./navbar.scss";
import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import i18n from "../../Other/i18n";
//calender import
import Cal from "./calender/Calendar";
import ProfileOptionsWrapper from "../ProfileOptions/ProfileOptionsWrapper";
import UserAvatar from "../UserAvatar/UserAvatar";
import { SearchBar } from "../../Other/Search/Search";
import axiosInstance from "../../../axios";
import OptionsComponent from "../assets/optionsComponent/OptionsComponent";
import { ro } from "date-fns/locale";
import { useSelector } from "react-redux";
import ChatbotWidget from "@components/ChatbotWidget";

const { REACT_APP_LOGIN_API_BASEURL } = process.env;

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state.users);
  const [lan, setLan] = useState(
    localStorage.getItem("language") ? localStorage.getItem("language") : "en"
  );
  const [systemMode, setSystemMode] = useState("live");

  const [notificationData, setNotificationData] = useState([]);
  const [unreadNotificationCount, setUnreadNotificationCount] = useState(0);
  const [pendingReviewsCount, setPendingReviewsCount] = useState(0);
  const [notification, SetNotification] = useState(0);
  const [profileShow, setProfileShow] = useState(false);
  const [insId, setInstructorId] = useState(null);
  const changeLanguage = (lng) => {
    setLan(lng);
    i18n.changeLanguage(lng);
    localStorage.setItem("language", lng);
  };

  const fetch = async () => {
    try {
      const url = user?.role == "1"
        ? `${REACT_APP_LOGIN_API_BASEURL}/announcement`
        : `${REACT_APP_LOGIN_API_BASEURL}/course-annnouncement`;
      const res = await axiosInstance.get(url);
      const announcements = (user?.role == "1" ? res?.data?.data : res?.data?.message) || [];
      
      const deletedIds = JSON.parse(localStorage.getItem("deleted_announcements") || "[]");
      const activeAnnouncements = announcements.filter((ann) => !deletedIds.includes(ann.id));
      setNotificationData(activeAnnouncements);

      const seenIds = JSON.parse(localStorage.getItem("seen_announcements") || "[]");
      const unreadCount = activeAnnouncements.filter((ann) => !seenIds.includes(ann.id)).length;
      setUnreadNotificationCount(unreadCount);
    } catch (error) {
      console.error("Error fetching course announcements:", error);
    }

    if (user?.role == "1") {
      try {
        const reviewsRes = await axiosInstance.get("/testimonials");
        const reviews = reviewsRes.data.data || [];
        const pendingCount = reviews.filter((r) => !r.parentId && (r.status === 0 || r.status === "0")).length;
        setPendingReviewsCount(pendingCount);
      } catch (error) {
        console.error("Error fetching pending reviews count in Navbar:", error);
      }
    }
  };


  const fetchNotification = async () => {
    try {
      const res = await axiosInstance.get("/admin/get-student-attendance");
      const attendanceList = res?.data?.data;

      if (Array.isArray(attendanceList)) {
        const filtered = attendanceList.filter(item => item?.instructorId === user?.id);
        setInstructorId(filtered[0]?.instructorId);

        const unreadCount = attendanceList.filter(
          (notification) => notification?.verified === 0 || notification?.verified === false
        ).length;

        SetNotification(unreadCount);
      } else {
        //console.log("Unexpected response format:", res?.data);
        SetNotification(0);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  const fetchSystemMode = async () => {
    try {
      const res = await axiosInstance.get("/system-mode");
      if (res?.data && !res.data.error) {
        setSystemMode(res.data.mode);
      }
    } catch (error) {
      console.error("Error fetching system mode:", error);
    }
  };

  useEffect(() => {
    fetch();
    fetchNotification();
    if (user?.role == "1") {
      fetchSystemMode();
    }
  }, [user, location.pathname]);

  useEffect(() => {
    const handleUpdate = () => {
      fetch();
      fetchNotification();
    };
    window.addEventListener("update_announcements_count", handleUpdate);
    return () => {
      window.removeEventListener("update_announcements_count", handleUpdate);
    };
  }, [user, pendingReviewsCount, unreadNotificationCount]);

  const handleToggleMode = async () => {
    const nextMode = systemMode === "live" ? "test" : "live";
    try {
      const res = await axiosInstance.post("/admin/system-mode", { mode: nextMode });
      if (res?.data && !res.data.error) {
        setSystemMode(res.data.mode);
      }
    } catch (error) {
      console.error("Error toggling system mode:", error);
    }
  };


  const handleNotificationClick = () => {
    navigate('/dashboard/announcements');
  };

  const handleNotificationClick1 = () => {
    if (insId === user?.id) {
      navigate('/dashboard/verify/attendance');
    }
    else {
      navigate('/dashboard/reminders');
    }
  };
  const profileFunc = (event) => {
    event.preventDefault();
    setProfileShow(!profileShow);
  };

  const handleSelectOption = () => {
    setProfileShow(!profileShow);
  };

  //icon menu to map item dynamically
  const iconMenu = [
    {
      key: 0,
      label: <Cal />,
      icon: "icon icon-calendar",
      class: "span-absolute-1",
      route: "/dashboard/calendar"
    },
    {
      key: 1,
      label: "Reminder",
      icon: "icon icon-reminder",
      class: "span-absolute-1",
      message: `${insId === user?.id ? notification : 0}`,
      route: `/${insId === user?.id ? 'dashboard/verifyAttendance' : 'dashboard/reminders'}`,
      onClick: handleNotificationClick1
    },
    {
      key: 2,
      icon: "icon icon-notification",
      class: "span-absolute-1",
      message: unreadNotificationCount,
      route: "/dashboard/announcements",
      onClick: handleNotificationClick
    },
    ...(user?.role == "1" ? [{
      key: 4,
      label: "Announcement",
      icon: "icon icon-announcement",
      class: "span-absolute-red",
      message: unreadNotificationCount + pendingReviewsCount,
      route: "/dashboard/Announcement"
    }] : []),
    {
      key: 3,
      label: "Settings",
      icon: "icon icon-settings",
      class: "span-absolute-1",
      route: "/dashboard/settings"
    },
  ];

  const languageOptinos = [
    { key: 0, value: "en", label: "EN", class: "english" },
    { key: 1, value: "fr", label: "FR", class: "french" },
  ];

  return (
    <div className="list">
      <div className="list-wrapper">
        {/* Hiding searchbar inside the dashboard topbar per USER request */}
        {/* <div className={"search-wrapper"}>
          <SearchBar variant="dashboard" />
        </div> */}

        <div className="nav-bar">
          <ul className="display-navbar-flex">
            {user?.role == "1" && (
              <li className="listItem system-mode-li">
                <div className="system-mode-toggle-container">
                  <span className={`mode-label ${systemMode}`}>
                    {systemMode === "live" ? "Live" : "Test"}
                  </span>
                  <button
                    className={`system-mode-switch ${systemMode}`}
                    onClick={handleToggleMode}
                    aria-label="Toggle System Mode"
                    title={`Switch to ${systemMode === "live" ? "Test" : "Live"} Mode`}
                  >
                    <span className="slider-knob"></span>
                  </button>
                </div>
              </li>
            )}
            <li className="listItems forTrans">
              {/* <OptionsComponent
                            className="language"
                            name={lan}
                            listsa={languageOptinos}
                            setValue={changeLanguage}
                        /> */}
            </li>

            {iconMenu.map((item) => {
              return (
                <li className="listItem" key={item.key}>
                  {item.onClick ? (
                    <div
                      onClick={item.onClick}
                      aria-label="Menu Navigation"
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="dashboard-navbar">
                        {item.message !== undefined && item.message != 0 && (
                          <span className={`${item.class}`}>
                            <p>{item?.message}</p>
                          </span>
                        )}
                        <span
                          className={`${item.icon} image-new-fluid-1`}
                        ></span>
                      </div>
                    </div>
                  ) : (
                    <Link
                      to={item.route || "/"}
                      aria-label="Menu Navigation"
                    >
                      <div className="dashboard-navbar">
                        {item.message !== undefined && item.message != 0 && (
                          <span className={`${item.class}`}>
                            <p>{item?.message}</p>
                          </span>
                        )}
                        <span
                          className={`${item.icon} image-new-fluid-1`}
                        ></span>
                      </div>
                    </Link>
                  )}
                </li>
              );
            })}
            <li className="listItem"><ChatbotWidget /></li>
            <li className="listItem">
              <a aria-label="Menu Navigation" href="/#" onClick={profileFunc}>
                <UserAvatar styleName="navbar-profile" navbar={true} />
              </a>
              {profileShow && (
                <ProfileOptionsWrapper onSelectOption={handleSelectOption} />
              )}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}